<template>

    <div>

        <div class="control" v-cloak>

            <!-- TEXTBOXES -->
            <template v-if="el.type.id==contentElementDataTypes.TEXTBOX.id">

                <div class="control-label">
                    <label-name :labelKey="'PAGE_ELEMENT-TEXTBOX_'+el.name"></label-name>
                </div>
                <div class="control">
                    <input :id="'PAGE_ELEMENT-TEXTBOX_'+el.name" class="input is-medium" type="text" v-model="el.value" :class="[{ 'is-disabled': (userRole == 'Redaktion' && (el.name == 'CONTENT_ELEMENT_DATA_RICH_TEXT_PRODUCT_BOX_HEADLINE' || el.name == 'CONTENT_ELEMENT_DATA_RICH_TEXT_PRODUCT_BOX_HEADER')) || isReadOnly}]" />
                    <!-- <input :id="'PAGE_ELEMENT-TEXTBOX_'+el.name" class="input is-medium" type="text" v-model="el.value" :class="[{ 'is-disabled': isReadOnly}]"> -->
                </div>

                <!-- input counter -->
                <template v-if="blueprint && blueprint.maxLength">

                    <transition name="fade" appear>
                        <div class="counter has-text-right" v-if="el.value">
                            <input-counter :inputData.sync="el.value" :limit="blueprint.maxLength"></input-counter>
                        </div>
                    </transition>
                </template>

            </template>


            <!-- TEXTAREAS -->
            <template v-else-if="el.type.id==contentElementDataTypes.TEXTAREA.id">


                <div class="control">

                    <div class="control-label">
                        <label-name :labelKey="'PAGE_ELEMENT-TEXTAREA_'+el.name"></label-name>
                    </div>

                    <div class="control">
                        <quill-editor
                            v-model="el.value"
                            ref="quillEditor"
                            :options="editorOptions"
                            key="quill">
                        </quill-editor>
                    </div>

                </div>


                <!--
                <div class="control-label">
                    <label-name :labelKey="'PAGE_ELEMENT-TEXTAREA_'+el.name"></label-name>
                </div>
                <div class="control textareaContentHeight">
                    <textarea type="textarea" class="textarea is-medium" v-model="el.value" :class="[{ 'is-disabled': (userRole == 'Redaktion' && el.name == 'CONTENT_ELEMENT_DATA_RICH_TEXT_PRODUCT_BOX_TEXT') || isReadOnly }, el.name]"></textarea>
                </div>
                -->

                <!-- input counter -->
                <template v-if="blueprint.maxLength">
                    <transition name="fade" appear>
                        <div class="counter has-text-right" v-if="el.value">
                            <input-counter :inputData.sync="el.value" :limit="blueprint.maxLength"></input-counter>
                        </div>
                    </transition>
                </template>

            </template>


            <!-- PRODUCT SELECTOR -->
            <template v-else-if="el.type.id==contentElementDataTypes.PRODUCT_SELECTOR.id">

                <div class="control-label">
                    <label-name :labelKey="'PAGE_ELEMENT-'+el.name"></label-name>
                </div>

                <div class="control">
                    <span class="select is-medium">
                        <select id="productSelector" v-model="el.product" :class="[{ 'is-disabled': userRole == 'Redaktion' }]" @change="changeProduct($event.target.value)">
                            <option :value="null">Produkt wählen ...</option>
                            <option v-for="product in products" :value="product.id">{{ product.name }}</option>
                        </select>
                    </span>
                </div>

            </template>


            <!-- ASSETS -->
            <template v-else-if="el.type.id==contentElementDataTypes.ASSETS.id">

                <div class="control-label">
                    <label-name :labelKey="'PAGE_ELEMENT-TEXTAREA_'+el.name"></label-name>
                </div>

                <div class="control">

                    <vue-dropzone
                        :ref="'vueDropzone'+'_'+randomIndex"
                        :id="'vueDropzone'+'_'+randomIndex"
                        :uploadMultiple="false"
                        url= "fileProcessing/upload?preset=contentElementAsset"
                        :thumbnailWidth = "140"
                        :thumbnailHeight = "60"
                        :isClickable="true"
                        dictDefaultMessage = "<i class='fa fa-cloud-upload'></i>Datei wählen oder per Drag & Drop hinzufügen"
                        v-on:vdropzone-success="dzSuccess($event, 'vueDropzone'+'_'+randomIndex)"
                        v-on:vdropzone-success-multiple="dzSuccessMultiple($event, 'vueDropzone'+'_'+randomIndex)"
                        dzClass="default">
                    </vue-dropzone>

                </div>

                <template v-if="el.assets.length">

                    <div class="control-label"></div>
                    <div class="control">
                        <assets :assets="el.assets" @removeAsset="removeAsset"></assets>
                    </div>

                </template>


            </template>

            <!-- PRODUCT BOX TYP -->
            <!-- User of type "Industriepartner" must not see this box -->
            <template v-else-if="el.type.id==contentElementDataTypes.PRODUCT_BOX_TYPE_SELECTOR.id && userRole != 'Industriepartner'">

                <div class="control-label">
                    <label-name :labelKey="'PAGE_ELEMENT-'+el.name"></label-name>
                </div>
                <div class="control">
                    <span class="select is-medium">
                        <select v-model="el.value" @change="productBoxTypeSelector" :class="[{ 'is-disabled': userRole == 'Redaktion' }]" >
                            <option v-for="(productType, key) in boxTypes" :value="productType.id">{{ $t('SELECT_PRODUCT_BOX_TYPE-'+productType.name) }}</option>
                        </select>
                    </span>
                </div>

            </template>


        </div>

    </div>
</template>



<script>
import vue2Dropzone from '../utils/dropzoneWrapper'
import assets from '../utils/incl-assets';
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'

export default {

    props: ['element', 'isReadOnly', 'blueprint', 'index', 'products'],

    data() {
 		return {
            el: this.element,
            isLoading: false,
            editorOptions: {
				modules: {
					toolbar: [
                        ['bold', 'italic', 'underline'],
                        [{ 'header': [3, 4, 5, 6, false] }],
						[{ 'script': 'super' }],
						[{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        ['link'],
						['clean']
					],
					history: {
						delay: 1000,
						maxStack: 50,
						userOnly: false
					}
				},
				readOnly: false,
				placeholder: ''
			},
        }
    },

    components: {
        vueDropzone: vue2Dropzone,
        assets,
    	quillEditor
    },

    computed: {

        userRole: function() {
			return this.$store.getters.getUserRole.name;
		},

        boxTypes() {
            return this.$store.getters.getTermsByTaxonomy('PRODUCT_BOX_TYPES');
        },

        contentElementDataTypes() {
            return this.$store.getters.getTermsByTaxonomy('CONTENT_ELEMENT_DATA_TYPES');
        },

        randomIndex() {
            return Math.random().toString(36).substring(7);
        }

    },

    created() {

        // check if element is of type "product box selector"
        if(this.el.type.id==this.contentElementDataTypes.PRODUCT_BOX_TYPE_SELECTOR.id) {

            // productBoxType should show "none" if no value is available
            if(this.el.value == "") {
                this.el.value = this.boxTypes.NONE.id;
            }
        }

        // if element is of type "assets", make sure that it has an assets array
        if(this.el.type.id==this.contentElementDataTypes.ASSETS.id) {

            if(!this.el.assets) {
                this.$set(this.el, 'assets', []);
            }
        }

        // make sure that empty textboxes are set to the default value if available
        if(typeof this.blueprint != "undefined" && typeof this.blueprint.default !== "undefined" && this.el.value == "") {
            this.el.value = this.blueprint.default;
        }

    },


    mounted() {

        // resize textareas (height) on textinput
        $('.textareaContentHeight').on( 'change keyup keydown paste cut', 'textarea', function (){
            $(this).height(0).height(this.scrollHeight);
        }).find('textarea').change();

    },

    methods: {

        changeProduct(productId) {

            this.$emit('changeProduct');
            // this.$emit('changeProduct', productId == '' ? null : productId);

        },

        productBoxTypeSelector: function() {

            this.$emit('productBoxType', this.el);

        },


        dzSuccess(file, id) {

			var result = JSON.parse(file.xhr.response);

			var newAsset = {
				asset: {
					filename: result.fileName,
					path: result.dir,
                    uploadFilename: file.name
				}
			}

            // push newly created obj into assets Array
            this.el.assets.push(newAsset);

			// remove image from dropzone after some time
            var self = this;
			setTimeout(function() {
                let x = self.$refs[id].$children[0];
				x.removeFile(file);
                self.$emit('save');
			}, 100)

		},

        removeAsset(payload) {

            let index = payload.index;
            this.el.assets.splice(index,1);
            // this.el.assets.splice(index,1);
            this.$emit('save');

		},


    }

}
</script>


<style scoped>

    .quill-editor {
        max-width: 100%;
    }
    .control > .control {
        max-width: 100%;
    }
    .CONTENT_ELEMENT_DATA_RICH_TEXT_TEXT {
        min-height: 500px;
    }

    >>> .ql-editor p {
        margin-bottom: 25px !important;
    }
    >>> .ql-editor h2,
    >>> .ql-editor h3 ,
    >>> .ql-editor h4,
    >>> .ql-editor h5,
    >>> .ql-editor h6 {
        margin: 0;
        padding: 0;
        font-weight: bold;
        font-size: inherit;
    }
    >>> .ql-editor h3 {
        font-size: 1.45rem;
        margin-bottom: 1rem;
    }
    >>> .ql-editor h4 {
        font-size: 1.2rem;
        margin-bottom: .1rem;
    }
    >>> .ql-editor h5 {
        font-size: 1rem;
        font-weight: normal;
    }

</style>
